import type { ReactNode } from 'react';
import clsx from 'clsx';
import React from 'react';
import { HotkeysProvider } from 'react-hotkeys-hook';

import type { ModalWidth } from '@fragment/ui/src/components/Modal/Modal';
import { Modal } from '@fragment/ui/src/components/Modal/Modal';

import { ExampleLedgerDashboard } from './exampleDashboard/ExampleLedgerDashboard';

type Props = {
  title: ReactNode;
  children: ReactNode;
  width?: ModalWidth;
  shouldCenter?: boolean;
};

export const ConnectionLayout = ({
  title,
  children,
  width = 'xs',
  shouldCenter = false,
}: Props) => (
  <HotkeysProvider initiallyActiveScopes={['modal']}>
    <div className="min-h-screen bg-canvas text-main">
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 select-none overflow-hidden bg-canvas text-main blur-[6px]"
      >
        <ExampleLedgerDashboard />
      </div>
      <Modal
        onClose={() => undefined}
        className={clsx(
          'max-h-[min(560px,calc(70dvh-1lh))] shadow-nice text-xmd text-main',
          width === 'sm' && 'laptop:!w-[720px]'
        )}
        width={width}
        shouldCenter={shouldCenter}
        shouldScrollBody
        verticalOffset={shouldCenter ? 'min-h-f2' : 'max-h-[30dvh] shrink-0'}
        header={title}
        body={children}
      />
    </div>
  </HotkeysProvider>
);
